import PersonAddIcon from '@mui/icons-material/PersonAdd'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

/**
 * "New" (new patient booking) button shown next to the Patient Search button on
 * the Appointments tab. Clicking it opens the same "Search or Create Patient"
 * booking dialog that is opened by clicking an empty slot on the Calendar tab.
 *
 * @param {Function} onClick - Opens the new booking dialog.
 * @param {boolean} [compact] - Render an icon-only button when horizontal space is limited.
 */
export default function NewBookingHeaderButton({ onClick, compact = false }) {
  if (!onClick) {
    return null
  }

  if (compact) {
    return (
      <Tooltip title="New patient booking">
        <IconButton
          size="small"
          onClick={onClick}
          sx={{
            flexShrink: 0,
            color: '#0f9d6b',
            backgroundColor: 'rgba(16, 185, 129, 0.12)',
            border: '1px solid rgba(16, 185, 129, 0.28)',
            padding: '8px',
            borderRadius: '10px',
            '&:hover': {
              backgroundColor: 'rgba(16, 185, 129, 0.2)',
              borderColor: 'rgba(16, 185, 129, 0.45)',
              color: '#0f9d6b',
            },
            transition: 'all 0.2s ease',
          }}
        >
          <PersonAddIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
    )
  }

  return (
    <Tooltip title="New patient booking">
      <Button
        variant="contained"
        startIcon={<PersonAddIcon />}
        onClick={onClick}
        sx={{
          flexShrink: 0,
          backgroundColor: '#10b981',
          color: 'white',
          fontWeight: 600,
          fontSize: '13px',
          padding: '8px 16px',
          borderRadius: '10px',
          textTransform: 'none',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 8px rgba(16, 185, 129, 0.25)',
          border: '1px solid rgba(16, 185, 129, 0.3)',
          '&:hover': {
            backgroundColor: '#059669',
            boxShadow: '0 4px 12px rgba(5, 150, 105, 0.35)',
            transform: 'translateY(-1px)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
          transition: 'all 0.2s ease',
          '& .MuiButton-startIcon': {
            marginRight: '6px',
            '& > *:nth-of-type(1)': {
              fontSize: '18px',
            },
          },
        }}
      >
        New
      </Button>
    </Tooltip>
  )
}
